import classNames from 'classnames';
import { EnrichmentError } from 'components/common-form/builder/form/enrichment-error';
import { FormTabGuard } from 'components/form-tab-guard';
import { useAssertedActiveTabId } from 'hooks/use-asserted-active-tab-id';
import { useAppSelector } from 'hooks/useAppSelector';
import { EssentialForm } from 'routes/essential-workspace/components/form';
import { EssentialFormSkeleton } from 'routes/essential-workspace/components/form-skeleton';
import { EssentialProductSelector } from 'routes/essential-workspace/components/product-selector';
import { QuotePanel } from 'routes/essential-workspace/components/quote-panel';
import { useScrollToSection } from 'routes/essential-workspace/components/right-panel/hooks/use-scroll-to-section';

import './style.scss';

type EssentialMainProps = {
  currentSectionId: string;
  isLayoutEditing: boolean;
};

export function EssentialMain({ currentSectionId, isLayoutEditing }: EssentialMainProps) {
  const tabId = useAssertedActiveTabId();
  const activeTabContent = useAppSelector(state => state.workspaces.essential[tabId]);

  useScrollToSection({ sectionId: currentSectionId, isEnabled: isLayoutEditing });

  if (activeTabContent?.isFetchingTabContent) {
    return <EssentialFormSkeleton isDefaultLoading={!activeTabContent?.isProductValidated} />;
  }

  if (activeTabContent?.isProductValidated === false) {
    return <EssentialProductSelector className="container-lg px-5 product-selector-container" />;
  }

  return (
    <FormTabGuard formId={tabId}>
      <EnrichmentError />
      <div className="container-xxl">
        <div className="row g-3">
          <div className="col-12 col-lg-7 pb-lg-5">
            <EssentialForm currentSectionId={currentSectionId} isLayoutEditing={isLayoutEditing} />
          </div>
          <div
            className={classNames(
              'col-12 col-lg-5 quote-aside-container',
              isLayoutEditing && 'essential-layout-inactive-section quote-aside-container-layout-editing',
            )}
          >
            <QuotePanel />
          </div>
        </div>
      </div>
    </FormTabGuard>
  );
}
